<template>
  <div class="tabs-wrap clearfix">
    <div class="left f-left">
      <CourseShowTeacher :teachers="teachers"></CourseShowTeacher>
      <div class="course-tabs-wrap">
        <BlockTabs :items="tabs" currentClass="bold5" isNew @changeTab="changeTab"></BlockTabs>
        <Rich
          id="course-detail"
          class="tab-content-detail"
          v-html="course.course_details"
          v-if="currentTab == 1"
          oncontextmenu="return false"
          onselectstart="return false"
        ></Rich>
        <Empty
          class="empty"
          v-if="course.course_details == '' && currentTab == 1"
          title="暂无课程介绍信息！"
        />
        <div id="course-chapter" class="tab-content-plan" v-show="currentTab == 2">
          <CourseChapter :course="course" @chapterClick="onChapterClick"></CourseChapter>
        </div>
        <CourseCert
          ref="cert"
          v-show="currentTab == 4"
          :url="'/api/app/cert/course/' + course.id"
          style="padding-top: 10px"
        ></CourseCert>
        <div v-show="currentTab == 3" class="tab-content-comment">
          <CourseComment
            :courseId="course.id"
            @complaint="(id) => $refs.complaint.show(1, id)"
            @load="onCommentLoad"
          ></CourseComment>
        </div>
        <div v-show="currentTab == 5" class="tab-content-exam">
          <CourseExam
            :courseId="course.id"
            v-for="exam in exams"
            :key="exam.id"
            :exam="exam"
          ></CourseExam>
          <Empty class="empty" v-if="exams.length == 0" title="暂无课程考试信息哦！" />
        </div>
      </div>
    </div>
    <CourseShowRecommend :recommendCourses="recommendCourses"></CourseShowRecommend>
    <Complaint ref="complaint"></Complaint>
  </div>
</template>
<script>
import CourseChapter from '../CourseChapter.vue';
import CourseComment from '../CourseComment.vue';
import CourseShowTeacher from './CourseShowTeacher.vue';
import CourseShowRecommend from './CourseShowRecommend.vue';
import Complaint from '@/components/community/components/Complaint.vue';
import CourseCert from './CourseCert.vue';
import CourseExam from '../CourseExam.vue';

export default {
  name: 'CourseShowTabs',
  components: {
    CourseChapter,
    CourseComment,
    CourseShowTeacher,
    CourseShowRecommend,
    Complaint,
    CourseCert,
    CourseExam,
  },
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    teachers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    recommendCourses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    exams: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    currentTab(newValue) {
      if (newValue == 4) {
        this.$refs.cert.searchRefresh();
      }
    },
  },
  data() {
    return {
      currentTab: '1',
      commentTotal: 0,
    };
  },
  computed: {
    tabs() {
      let tabs = [{ id: 1, name: '课程介绍' }];
      tabs.push({ id: 2, name: '课程大纲' });
      if (this.course.cert == 1 && this.$store.state.commonSetting.switch_cert_module == 1) {
        tabs.push({ id: 4, name: '课程证书' });
      }
      tabs.push({ id: 3, name: '课程评价 (' + this.commentTotal + ')' });
      if (this.exams.length > 0) {
        tabs.push({ id: 5, name: '课程考试' });
      }
      return tabs;
    },
  },
  methods: {
    changeTab(item) {
      this.currentTab = item.id;
    },
    onChapterClick(id) {
      this.$nextTick(() => {
        let offset = window.$('#chapter-' + id).offset();
        let top = offset.top - 84;
        window.$(document.documentElement).scrollTop(top);
      });
    },
    onCommentDelete() {
      this.$emit('commentDelete');
    },
    onCommentLoad({ total }) {
      this.commentTotal = total || 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs-wrap {
  margin-bottom: 70px;
  .left {
    width: 882px;
  }
}

.course-tabs-wrap {
  background: white;
  border-radius: 5px;
  padding-top: 12px;

  ::v-deep {
    .tabs,
    .tab-item {
      border-radius: 5px;
    }
    .tab-item {
      margin-right: 0 !important;
      width: 124px !important;
    }
    .el-tabs__header {
      margin-bottom: 0;
    }
  }

  .empty,
  .tab-content-comment {
    border-radius: 15px;
  }

  .tab-content-detail {
    padding: 32px;
  }

  .tab-content-comment {
    padding: 0 32px 16px 32px;
  }
  .tab-content-exam {
    padding: 0 24px 32px 24px;
    ::v-deep .exam-item {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
